import React, { useRef } from 'react';
import {
  AdminContainer,
  AdminBody,
  FormBody,
  FormTitle,
  FormText,
  FormInfo,
  FormCode,
  FormNumber,
  FormPlace,
  TextUser,
  FormContainer,
  FormButton,
  ImageSimulator,
  SimulatorImg
} from './AdministratorBodyStyled';
import ImgSimulator from '../../../../../assets/icons/ImgSimulator.svg';
import AlertIcon from '../../../../../assets/icons/IconAlert.svg';

interface AdminBodyProps {
  handleActiveSimulate: (studentCode: any) => void;
  error: any;
  handleInputChange: (code: string) => void;
  disabled: boolean;
}

const AdminBodyView = (props: AdminBodyProps) => {
  const { handleActiveSimulate, error, handleInputChange, disabled } = props;
  const studentCodeRef: any = useRef<any>();

  return (
    <AdminContainer>
      <AdminBody>
        <FormBody>
          <FormTitle>Portal administrador</FormTitle>
          <FormText>Simulación de accesos de alumno</FormText>
          <FormInfo>
            Ingresa el código del alumno y podrás simular la vista del
            estudiante y ver toda su información.
          </FormInfo>
          <FormCode>
            Código<FormNumber>(de 7 a 9 caracteres)</FormNumber>
          </FormCode>
          <FormPlace>
            <TextUser
              data-testid="cmp-admin-input-find-student"
              ref={studentCodeRef}
              type="text"
              className={error && 'borderError'}
              placeholder="Ingrese código de alumno"
              onChange={() => handleInputChange(studentCodeRef.current.value)}
              onKeyDown={(event) =>
                event.keyCode === 13 &&
                handleActiveSimulate(studentCodeRef.current.value)
              }
            />
            <div className={error ? 'showError' : 'hideError'}>
              <img className="paddingAll" src={AlertIcon} alt="alertIcon" />
              <div className="colorError">Código de alumno inválido</div>
            </div>
          </FormPlace>
          <FormContainer>
            <FormButton
              data-testid="cmp-admin-button-find-student"
              className={disabled ? 'disableButton' : 'enableButton'}
              type="button"
              onClick={() => handleActiveSimulate(studentCodeRef.current.value)}
            >
              Simular
            </FormButton>
          </FormContainer>
        </FormBody>
        <ImageSimulator>
          <SimulatorImg src={ImgSimulator} alt="ImgSimulator" />
        </ImageSimulator>
      </AdminBody>
    </AdminContainer>
  );
};
export default AdminBodyView;
